import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import getUserNameInitials from 'common/util/getUserNameInitials';

import './SrUserNameCircle.less';

export const USER_NAME_GREEN_THEME = 'green';
export const USER_NAME_ORANGE_THEME = 'orange';

const THEME_TO_CLASSNAME_MAPPING = {
  [USER_NAME_GREEN_THEME]: 'green',
  [USER_NAME_ORANGE_THEME]: 'orange',
};
const THEMES = Object.keys(THEME_TO_CLASSNAME_MAPPING);

const SrUserNameCircle = ({ name, theme }) => {
  return (
    <div styleName={classNames('userNameCircle', theme)}>
      <span>{getUserNameInitials(name)}</span>
    </div>
  );
};

SrUserNameCircle.propTypes = {
  name: PropTypes.string,
  theme: PropTypes.oneOf(THEMES),
};

SrUserNameCircle.displayName = 'SrUserNameCircle';

export default SrUserNameCircle;
